import React from "react";
import { Link } from "react-router-dom";
import { BorderImage } from "../../constants/svgPath";
import imagePath from "../../constants/imagePath";
import LatestNews from "../../Components/LatestNews";

function CaseStudiesDetail() {
  return (
    <>
      <section className="hero_sec casebg">
        <div className="contair ">
          <div className="hero_l">
            <div className="bread">
              <Link to="">Case-Studies </Link>{" "}
              <span>/ E-commerce Mobile App for Fashion Retailer</span>
            </div>
            <div className="hero_heading">
              <h1>E-commerce Mobile App for Fashion Retailer</h1>
              <p>
                To modernize customer engagement and scale online sales, the
                client – a fast-growing fashion retailer – approached Girips
                Technologies to build a mobile app that provides seamless
                shopping, personalized experiences, and efficient backend
                operations.
              </p>
            </div>
            <ul className="hero_ind">
              <li className="hero_pt">
                <p>Industry</p>
                <h3>E-commerce</h3>
                <span>
                  <BorderImage />
                </span>
              </li>
              <li className="hero_pt">
                <p>Client Location</p>
                <h3>United States</h3>
                <span>
                  <BorderImage />
                </span>
              </li>
              <li className="hero_pt">
                <p>Project Duration</p>
                <h3>12 months</h3>
                <span>
                  <BorderImage />
                </span>
              </li>
              <li className="hero_pt">
                <p>Team Size</p>
                <h3>25 members</h3>
              </li>
              <li className="hero_pt hero_last">
                <p>Key Technologies</p>
                <h3>
                  React Native, Node.js, MongoDB, AWS, Stripe, Firbase, Google
                  Analytics
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="prj_sec">
        <div className="contair ">
          <div className="next_heading">
            <h2>Project Scope of E-commerce Mobile app</h2>
            <p>
              The project aimed to design and develop a feature-rich e-commerce
              mobile application tailored for a fashion retailer. The scope
              included creating a visually engaging product catalog with
              advanced filtering options, secure multi-payment checkout, and
              real-time inventory synchronization across online and offline
              stores. A key focus was on enabling personalized product
              recommendations based on user behavior, as well as integrating
              push notifications to boost engagement and conversions.
              Additionally, the project required building an intuitive admin
              dashboard to manage products, track sales, monitor customer
              behavior, and gain actionable insights through analytics.
            </p>
          </div>
        </div>
      </section>
      <section className="approch_sec">
        <div className="contair ">
          <div className="approch_flx">
            <div className="approch_l">
              <div className="heading">
                <h2>Our Implementation Approach.</h2>
                <p>
                  A well-defined, step-by-step implementation process designed
                  to deliver seamless, scalable, and future-ready digital
                  solutions effectively.
                </p>
              </div>
              <figure>
                <img src={imagePath.Approch} alt="" />{" "}
              </figure>
            </div>
            <div className="approch_r">
              <ul className="approch_list">
                <li className="approch_pt">
                  <span>01</span>
                  <div className="approch_tx">
                    <h3>Discovery & Requirement Gathering</h3>
                    <p>
                      Defined app goals through interviews, personas, and
                      competitor analysis.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>02</span>
                  <div className="approch_tx">
                    <h3>Design Phase</h3>
                    <p>
                      Designed wireframes, prototypes, and gathered feedback for
                      intuitive shopping.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>03</span>
                  <div className="approch_tx">
                    <h3>Development & Agile Sprints</h3>
                    <p>
                      Built essential shopping features, adding recommendations
                      and push notifications.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>04</span>
                  <div className="approch_tx">
                    <h3>QA, Testing & Launch</h3>
                    <p>
                      Tested app thoroughly, launched beta, then rolled into
                      production.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>05</span>
                  <div className="approch_tx">
                    <h3>Post-Launch Optimization</h3>
                    <p>
                      Enhanced performance and user experience with
                      feedback-driven refinements.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="here_sec">
        <div className="contair ">
          <div className="heading">
            <h2>Here’s How We Make It Seamless</h2>
          </div>
          <div className="here_flx">
            <div className="here_inr">
              <div className="here_hdg">
                <h3>Challenges</h3>
                <p>Overcoming challenges for seamless project success.</p>
              </div>
              <ul className="approch_list">
                <li className="approch_pt">
                  <span>01</span>
                  <div className="approch_tx">
                    <h3>Fragmented customer journey</h3>
                    <p>
                      Disparate systems for browsing, cart, checkout, and
                      loyalty caused drop-offs.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>02</span>
                  <div className="approch_tx">
                    <h3>High cart abandonment</h3>
                    <p>
                      Complex checkout processes and inconsistent payment
                      methods.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>03</span>
                  <div className="approch_tx">
                    <h3>Slow performance</h3>
                    <p>
                      Large image loads and inventory sync issues created lag.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>04</span>
                  <div className="approch_tx">
                    <h3>Lack of personalization</h3>
                    <p>
                      No recommendation engine to suggest products tailored to
                      individual tastes.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="here_inr">
              <div className="here_hdg">
                <h3>Our Solutions</h3>
                <p>Innovative solutions tailored to client needs.</p>
              </div>
              <ul className="approch_list">
                <li className="approch_pt">
                  <span>01</span>
                  <div className="approch_tx">
                    <h3>Seamless Shopping Experience</h3>
                    <p>
                      Cross-platform apps with smooth navigation and rich
                      product browsing.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>02</span>
                  <div className="approch_tx">
                    <h3>Secure & Flexible Payments</h3>
                    <p>
                      Secure checkout with multiple payment options for smooth,
                      hassle-free transactions.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>03</span>
                  <div className="approch_tx">
                    <h3>Smart Product Recommendations</h3>
                    <p>
                      AI-powered engine delivering personalized suggestions to
                      boost engagement and sales.
                    </p>
                  </div>
                </li>
                <li className="approch_pt">
                  <span>04</span>
                  <div className="approch_tx">
                    <h3>Real-Time Insights & Control</h3>
                    <p>
                      Admin dashboard enables analytics, order tracking, and
                      push notifications seamlessly.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="mils_sec">
        <div className="contair ">
          <div className="next_heading">
            <h2>Our Milestone Highlights</h2>
          </div>
          <div className="mils_tbl">
            <table>
              <thead>
                <tr>
                  <th>Milestone</th>
                  <th>Tasks</th>
                  <th>Timeline</th>
                  <th>Responsible</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Project Initiation</td>
                  <td>
                    <p>
                      Market Analysis, Feature Prioritization, Budget and
                      Timeline Allocation, Strategic Project Planning
                    </p>
                  </td>
                  <td>Month 1-2</td>
                  <td>Project Manager</td>
                </tr>
                <tr>
                  <td>System Design and Prototype</td>
                  <td>
                    <p>
                      Designed System Tech Architecture, Curated Data Models
                    </p>
                  </td>
                  <td>Month 3-4</td>
                  <td>Solution Architect</td>
                </tr>
                <tr>
                  <td>Development and Model Training</td>
                  <td>
                    <p>
                      Mobile app core modules, AI integration, fine-tuning, and
                      training
                    </p>
                  </td>
                  <td>Month 5-7</td>
                  <td>Development Team</td>
                </tr>
                <tr>
                  <td>Testing and QA</td>
                  <td>
                    <p>Unit Testing, Automated Testing, Manual Testing</p>
                  </td>
                  <td>Month 8-9</td>
                  <td>QA Team</td>
                </tr>
                <tr>
                  <td>Deployment</td>
                  <td>
                    <p>System configuration, Data migration</p>
                  </td>
                  <td>Month 10-12</td>
                  <td>IT Team, Project Manager</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <LatestNews />
    </>
  );
}

export default CaseStudiesDetail;
